












































import { Component, Vue } from "vue-property-decorator";
import FooterUI from "@/components/FooterUI.vue";
import Makimono from "@/components/Makimono.vue";
import Sounds from "@/components/Sounds.vue";
import "animate.css/animate.css";
@Component({
  components: {
    "footer-ui": FooterUI,
    Makimono,
    Sounds
  }
})
export default class Prologue extends Vue {
  $refs!: {
    se: HTMLAudioElement;
    bgm: HTMLAudioElement;
    sounds: Sounds;
  };

  state = 0;

  mounted() {
    this.$refs.sounds.$refs.bgm.play();
    document.addEventListener("keypress", this.onKeyPress);
  }

  destroyed() {
    document.removeEventListener("keypress", this.onKeyPress);
  }

  onKeyPress(e: KeyboardEvent) {
    if (e.key === "Enter") {
      this.next();
    } else if (e.key === "r") {
      this.$router.push("/en");
    }
  }

  toGame() {
    this.$router.push("/en/game");
  }

  next() {
    this.playSE();
    window.setTimeout(() => {
      if (this.state == 1) {
        this.state = 2;
      } else {
        this.toGame();
      }
    }, 1000);
  }

  playSE() {
    this.$refs.sounds.$refs.se.pause();
    this.$refs.sounds.$refs.se.currentTime = 0;
    this.$refs.sounds.$refs.se.play();
  }
}
